// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"167":"detail","177":"home"}[chunkId] + "." + {"167":"977af77e","177":"b85c30e5"}[chunkId] + ".css";
};